export const waitForToken = async (key, timeout = 500, interval = 100) => {
  return new Promise((resolve) => {
    const startTime = Date.now();
    const check = () => {
      const token = localStorage.getItem(key);
      if (token) resolve(token);
      else if (Date.now() - startTime >= timeout) resolve(null);
      else setTimeout(check, interval);
    };
    check();
  });
};
